import { Draft, produce } from 'immer';

import * as TYPES from '@app/store/actionTypes';
import {
  scheduledDocumentPreviewDataFetched,
  setTemplateParticipants,
  setupTemplateByDraft,
  TemplateAction,
} from '@app/store/template/actions';

export interface TemplateParticipantFieldState {
  [id: string]: string[];
}

const initialState: TemplateParticipantFieldState = {};

const reducer = produce((draft: Draft<TemplateParticipantFieldState>, action: TemplateAction) => {
  switch (action.type) {
    case TYPES.TEMPLATE_CLEAR_ALL_STATE:
    case TYPES.TEMPLATE_INFORMATION_FETCH_REQUEST:
      return initialState;
    case TYPES.TEMPLATE_INFORMATION_FETCH_SUCCESS:
    case scheduledDocumentPreviewDataFetched.type: {
      const { participants } = action.payload;
      participants.forEach((participant) => {
        const { id, fields } = participant;
        const { checkboxGroups, signatureFields, textFields } = fields;

        if (!(id in draft)) {
          draft[id] = [];
        }
        checkboxGroups.forEach((checkboxGroup) => {
          draft[id].push(checkboxGroup.id);
          checkboxGroup.children.forEach((checkboxField) => {
            draft[id].push(checkboxField.id);
          });
        });

        signatureFields.forEach((signatureField) => {
          draft[id].push(signatureField.id);
        });
        textFields.forEach((textField) => {
          draft[id].push(textField.id);
        });
      });
      return draft;
    }
    case setupTemplateByDraft.type: {
      action.payload.participants.forEach((participant) => {
        const { id, fields } = participant;

        if (!draft[id]) {
          draft[id] = [];
        }

        fields.forEach((field) => {
          draft[id].push(field.id);
        });
      });

      return draft;
    }
    case setTemplateParticipants.type: {
      action.payload.forEach(({ id }) => {
        draft[id] = draft[id] ?? [];
      });

      return draft;
    }
    case TYPES.TEMPLATE_FIELD_CREATE: {
      const { participantId, id } = action.payload.meta;
      draft[participantId].push(id);
      return draft;
    }
    case TYPES.TEMPLATE_FIELD_DELETE: {
      const { participantId, id } = action.payload;
      const index = draft[participantId].findIndex((v) => v === id);
      if (index !== -1) {
        draft[participantId].splice(index, 1);
      }
      return draft;
    }
    case TYPES.TEMPLATE_PARTICIPANT_DELETE: {
      const { id } = action.payload;
      delete draft[id];
      return draft;
    }
    case TYPES.TEMPLATE__FIELDS_OVER_MAX_DOCUMENT_PAGE_DELETE: {
      const { fieldIds } = action.payload;
      const participantIds = Object.keys(draft);
      participantIds.forEach((participantId) => {
        fieldIds.forEach((fieldId) => {
          const index = draft[participantId].findIndex((v) => v === fieldId);
          if (index !== -1) {
            draft[participantId].splice(index, 1);
          }
        });
      });
      return draft;
    }
    default:
      return draft;
  }
}, initialState);

export default reducer;
